/*
 * @description  :
 * @Author       : Junfeng Fu
 * @Date         : 2022-11-25 16:31:29
 * @LastEditors: Junfeng Fu
 * @LastEditTime: 2025-11-12 17:00:17
 */
const AllUrl = {
  dev: {
    baseUrl: 'http://192.168.1.103:5007',
    // baseUrl: 'https://192.168.1.239:5013', // 接口调用ip
    uploadUrl: 'http://192.168.1.103:5004', // 资源上传ip
    resourceUrl: 'http://192.168.1.103:7011', // 资源访问路径
    // resourceUrl: 'https://192.168.1.239:5544/', // 资源访问路径
    webUrl: 'https://192.168.1.239:5008/#/login/syatmb', // 个人中心
    studyPath: 'https://192.168.1.239:5010', // 学习子系统访问路径
    enterpriseNumber: '/login', // 单位名称
    enterpriseRealNumber: 'syatmb', // 单位名称
    showCompanyName: true // 是否显示单位名称 爱维译
    // baseUrl: 'http://192.168.1.105:5007' // 接口调用ip
    // uploadUrl: 'https://192.168.1.239:5012', // 资源上传ip
    // resourceUrl: 'https://192.168.1.239:5544/', // 资源访问路径
    // webUrl: 'https://192.168.1.239:5008/#/login/syatmb', // 个人中心
    // studyPath: 'https://192.168.1.239:5010', // 学习子系统访问路径
    // enterpriseNumber: '/login', // 单位名称
    // enterpriseRealNumber: 'syatmb', // 单位名称
    // showCompanyName: true // 是否显示单位名称 爱维译
    // baseUrl: 'https://avie.ltd:15013', // 接口调用ip
    // uploadUrl: 'https://avie.ltd:15012', // 资源上传ip
    // resourceUrl: 'https://avie.ltd:15544/', // 资源访问路径
    // webUrl: `https://avie.ltd:15008/#/login/syatmb`, // 网站访问地址
    // studyPath: 'https://avie.ltd:15010', // 学习子系统访问路径
    // enterpriseNumber: '/login', // 单位名称
    // enterpriseRealNumber: 'syatmb', // 单位名称
    // showCompanyName: true // 是否显示单位名称 爱维译
  },

  test: {
    baseUrl: 'http://192.168.1.220:5007', // 服务器
    uploadUrl: 'http://192.168.1.220:5004', // 文件上传
    resourceUrl: 'http://192.168.1.220:20001/', // 资源访问路径
    webUrl: 'http://192.168.1.220:20083', // 个人中心地址
    studyPath: 'https://192.168.1.220:20006', // 学习子系统访问路径
    rtmp: `rtmp://52.83.93.14/vod platform/`,
    enterpriseNumber: '/login', // 单位名称
    enterpriseRealNumber: 'syatmb', // 单位名称
    showCompanyName: true // 是否显示单位名称 爱维译
  },
  pre: {
    // --------2025-04-22修改-----------
    // baseUrl: 'https://front.gateway.nwatmb.icao.caetp.cn', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.nwatmb.icao.caetp.cn', // 资源上传ip
    // resourceUrl: 'https://resource.nwatmb.icao.caetp.cn/', // 资源访问路径
    // webUrl: 'https://aets.nwatmb.icao.caetp.cn/#/login/csatmb', // 网站访问地址
    // studyPath: 'https://study.nwatmb.icao.caetp.cn', // 学习子系统访问路径
    // showCompanyName: true // 是否显示单位名称 爱维译
    // -------------------
    baseUrl: 'https://192.168.1.239:6013', // 接口调用ip
    uploadUrl: 'https://192.168.1.239:6012', // 资源上传ip
    resourceUrl: 'https://192.168.1.239:5544/', // 资源访问路径
    webUrl: 'http://192.168.1.239:30304//#/login/syatmb', // 网站访问地址
    studyPath: 'https://192.168.1.239:30306', // 学习子系统访问路径
    enterpriseNumber: '/login', // 单位名称
    enterpriseRealNumber: 'syatmb', // 单位名称
    showCompanyName: true // 是否显示单位名称 爱维译
  },

  // 语音教室
  masteryy: {
    // baseUrl: 'https://192.168.0.239:6013',
    // uploadUrl: 'https://192.168.0.239:6012',
    // resourceUrl: 'https://192.168.0.239:5544/',
    // webUrl: 'https://192.168.0.239:5008/#/login/syatmb',
    // studyPath: 'https://192.168.0.239:5010',
    // enterpriseNumber: '/login',
    // enterpriseRealNumber: 'syatmb',
    // showCompanyName: true

    baseUrl: 'https://10.29.6.113:6013',
    uploadUrl: 'https://10.29.6.113:6012',
    resourceUrl: 'https://10.29.6.113:5544/',
    webUrl: 'https://10.29.6.113:5008/#/login/syatmb',
    studyPath: 'https://10.29.6.113:5010',
    enterpriseNumber: '/login',
    enterpriseRealNumber: 'syatmb',
    showCompanyName: true
  },

  pro: {
    // baseUrl: 'https://front.gateway.csatmb.com', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.csatmb.com', // 资源上传ip
    // resourceUrl: 'https://resource.csatmb.com/', // 资源访问路径
    // webUrl: 'https://aets.peixun.csatmb.com/#/login/csatmb', // 网站访问地址
    // studyPath: 'http://study.csatmb.com', // 学习子系统访问路径
    // showCompanyName:true, //是否显示单位名称 爱维译

    // 复制的以前项目的
    // baseUrl: 'http://front.gateway.xinjiang.caetp.cn', // 接口调用ip
    // uploadUrl: 'http://uploadfiles.xinjiang.caetp.cn', // 资源上传ip
    // resourceUrl: 'http://resource.xinjiang.caetp.cn/', // 资源访问路径
    // webUrl: 'http://test.xinjiang.caetp.cn/#/login/csatmb', // 网站访问地址
    // studyPath: 'http://study.xinjiang.caetp.cn', // 学习子系统访问路径
    // showCompanyName:true, //是否显示单位名称 爱维译

    // 西南/首都机场试用
    // baseUrl: 'https://front.gateway.icao.caetp.cn', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.icao.caetp.cn', // 资源上传ip
    // resourceUrl: 'https://resource.icao.caetp.cn/', // 资源访问路径
    // webUrl: 'https://aets.peixun.icao.caetp.cn/#/login/csatmb', // 网站访问地址
    // studyPath: 'https://study.icao.caetp.cn', // 学习子系统访问路径
    // showCompanyName:true, //是否显示单位名称 爱维译

    // 中南
    // baseUrl: 'https://front.gateway.csatmb.com', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.csatmb.com', // 资源上传ip
    // resourceUrl: 'https://resource.csatmb.com/', // 资源访问路径
    // webUrl: 'https://aets.peixun.csatmb.com/#/login/csatmb', // 个人中心
    // studyPath: 'https://study.csatmb.com', // 学习子系统访问路径
    // showCompanyName: true // 是否显示单位名称 爱维译

    // 北京空管局
    // baseUrl: 'https://front.gateway.icao.caetn.cn', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.icao.caetn.cn', // 资源上传ip
    // resourceUrl: 'https://resource.icao.caetn.cn/', // 资源访问路径
    // webUrl: 'https://aets.peixun.icao.caetn.cn/#/login/login', // 个人中心
    // studyPath: 'https://study.icao.caetn.cn', // 学习子系统访问路径
    // enterpriseNumber: '/login/csatmb', // 单位名称
    // showCompanyName: true // 是否显示单位名称 爱维译

    // 西北
    // baseUrl: 'https://front.gateway.nwatmb.cn', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.nwatmb.cn', // 资源上传ip
    // resourceUrl: 'https://resource.nwatmb.cn/', // 资源访问路径
    // webUrl: 'https://nwatmb.cn/#/login/csatmb', // 个人中心
    // studyPath: 'https://study.nwatmb.cn', // 学习子系统访问路径
    // showCompanyName: true // 是否显示单位名称 爱维译

    // 三亚
    // baseUrl: 'https://front.gateway.icao.syatmb.com', // 接口调用ip
    // uploadUrl: 'https://uploadfiles.icao.syatmb.com', // 资源上传ip
    // resourceUrl: 'https://resource.icao.syatmb.com/', // 资源访问路径
    // webUrl: 'https://syatmb.com/#/login/syatmb', // 个人中心
    // studyPath: 'https://study.icao.syatmb.com', // 学习子系统访问路径
    // enterpriseNumber: '/login/syatmb', // 单位名称
    // showCompanyName: true // 是否显示单位名称 爱维译

    // 空工大互联网
    // baseUrl: 'https://avie.ltd:15013', // 接口调用ip
    // uploadUrl: 'https://avie.ltd:15012', // 资源上传ip
    // resourceUrl: 'https://avie.ltd:15544/', // 资源访问路径
    //  webUrl: `https://avie.ltd:15008/#/login/syatmb`, // 网站访问地址
    //  studyPath: 'https://avie.ltd:15010', // 学习子系统访问路径
    // enterpriseNumber: '/login', // 单位名称
    //  enterpriseRealNumber: 'syatmb', // 单位名称
    //  showCompanyName: true // 是否显示单位名称 爱维译

    baseUrl: 'https://icaoenglish.com.cn:8002', // 接口调用ip
    uploadUrl: 'https://icaoenglish.com.cn:8003', // 资源上传ip
    resourceUrl: 'https://icaoenglish.com.cn:8004/', // 资源访问路径
    webUrl: 'https://icaoenglish.com.cn:8000/#/login/syatmb', // 网站访问地址
    studyPath: 'https://icaoenglish.com.cn:8005', // 学习子系统访问路径
    enterpriseNumber: '/login/syatmb', // 单位名称
    enterpriseRealNumber: 'syatmb', // 单位名称
    showCompanyName: true // 是否显示单位名称 爱维译
  }
}
const VUE_APP_ENV = process.env.VUE_APP_ENV || 'dev'
console.log(VUE_APP_ENV, 'website VUE_APP_ENV ===============>')
export default AllUrl[VUE_APP_ENV]



// WEBPACK FOOTER //
// ./src/utils/config.js